import React, { useState, useEffect, useRef } from "react";
import CommonDropdown from "../CommonDropdown";
import RDD from "../Sales/RDD";
import Map from "../../MapContienent";
import { useSelector } from "react-redux";
import Roomrental from "./RoomRental";
import Decor from "./Decor";
import Vendor from "./Vendor";
import Eventdaycharges from "./EventDayCharges";
import Beverage from "./Beverage";
import Rescheduling from "./Rescheduling";
import Adjustment from "./Adjustment";
import Deficit from "./Deficit";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import { baseURL } from "../../../Util/axios_helper";
import SalesMap from "./SalesMap";
import { printDocument } from "../../../ChartsJs/DownlaodExportImage";

const Sales = () => {
  const [GeoShow, setGeoShow] = useState(false);
  const { revenuData, selectedMonth, refresh, type, year, metrics } =
    useSelector((state) => state.revenue);
  const { SalesData } = useSelector((state) => state.sales);

  const [Carddata, setCarddata] = useState({
    Total: 0,
    Roomrental: 0,
    Decor: 0,
    RDD: 0,
    Vendor: 0,
    EventdayCharge: 0,
    Reschedulingfee: 0,
    Beveragesfee: 0,
    Adjustments: 0,
    Deficit: 0,
    Other: 0,
  });

  const [reportcolumn, setreportcolumn] = useState({
    Reportflag: false,
    Roomrental: true,
    Decor: true,
    RDD: true,
    Vendor: true,
    EventdayCharge: true,
    Reschedulingfee: true,
    Beveragesfee: true,
    Adjustments: true,
    Deficit: true,
    Other: true,
    title: "",
    exportFName: "",
    refreshflag: 0,
    reportvalue: "",
  });

  useEffect(() => {
    if (SalesData && SalesData.Table4Records) {
      const Totalsales =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "total"
        )?.Count || 0;

      const Roomrental =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "roomrental"
        )?.Count || 0;

      const Decor =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "decor"
        )?.Count || 0;

      const RDD =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "rdd"
        )?.Count || 0;

      const Vendor =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "vendor"
        )?.Count || 0;

      const EventdayCharge =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "eventdaycharge"
        )?.Count || 0;
      const Reschedulingfee =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "reschedulingfee"
        )?.Count || 0;
      const Beveragesfee =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "beveragesfee"
        )?.Count || 0;
      const Adjustments =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "adjustments"
        )?.Count || 0;
      const Deficit =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "deficit"
        )?.Count || 0;
      const Other =
        SalesData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "other"
        )?.Count || 0;

      setCarddata((prevCarddata) => ({
        ...prevCarddata,
        Total: Totalsales,
        Roomrental: Roomrental,
        Decor: Decor,
        RDD: RDD,
        Vendor: Vendor,
        EventdayCharge: EventdayCharge,
        Reschedulingfee: Reschedulingfee,
        Beveragesfee: Beveragesfee,
        Adjustments: Adjustments,
        Deficit: Deficit,
        Other: Other,
      }));
    }
  }, [SalesData]);

  useEffect(() => {
    if (selectedMonth && selectedMonth.length > 1) {
      if (selectedMonth.includes("0") || selectedMonth.length === 0) {
        setFlag(false);
      } else if (selectedMonth.length === 1) {
        setFlag(true);
      } else {
        setFlag(false);
      }
    }
  }, [refresh]);

  const formatNumberUS = (num) => {
    if (num >= 1000000000) {
      // 1 billion or more
      return `$${(num / 1000000000).toFixed(2)}B`; // Billion
    } else if (num >= 1000000) {
      // 1 million to 999 million
      return `$${(num / 1000000).toFixed(2)}M`; // Million
    } else if (num >= 1000) {
      // 1 thousand to 999 thousand
      return `$${(num / 1000).toFixed(2)}K`; // Thousand
    } else if (num <= -1000) {
      return `$${num.toFixed(2)}K`;
    }
    return `$${num}`; // Less than a thousand
  };

  const SalesRef = useRef();
  const handlePrintDocument = () => {
    const orientation = "portrait";
    printDocument(SalesRef, "Sales", orientation);
  };

  return (
    <>
      <button
        className="pfdexportIcon"
        onClick={handlePrintDocument}
        title="Download Full Screen"
      >
        <i className="lar la-file-pdf"></i>
      </button>
      <div className="pdfContent" ref={SalesRef}>
        <div className="page-header">
          <div className="row">
            <div className="col-sm-3">
              <h3 className="page-title">Sales</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Sales</li>
              </ul>
            </div>
            <div className="col-sm-9">
              <CommonDropdown setGeoShow={setGeoShow} sales={true} />
            </div>
          </div>
        </div>
        <div className="row eleven-cols">
          <div
            className="col-md-1  Widget-hover"
            title="View Total Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: false,
                  Decor: false,
                  RDD: true,
                  Vendor: false,
                  EventdayCharge: false,
                  Reschedulingfee: false,
                  Beveragesfee: false,
                  Adjustments: true,
                  Deficit: false,
                  Other: false,
                  title: "Total Sales Report",
                  exportFName: "Sales_Total_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "total",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-file-invoice-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Total)}</h3>
                    <span> Total Sales</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Room Rental Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: false,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total Room Rental Sales Report",
                  exportFName: "Sales_Roomrental_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "roomrental",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-file-invoice-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Roomrental)}</h3>
                    <span> Room Rental</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Decor Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: false,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total Decor Sales Report",
                  exportFName: "Sales_Decor_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "decor",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-comments-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Decor)}</h3>
                    <span> Decor</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total RDD Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: false,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total RDD Sales Report",
                  exportFName: "Sales_RDD_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "rdd",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-comment-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.RDD)}</h3>
                    <span> RDD</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Vendor Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: false,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total Vendor Sales Report",
                  exportFName: "Sales_Vendor_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "vendor",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-funnel-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Vendor)}</h3>
                    <span>Vendor</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Event Day Charges Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: false,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total Event Day Charges Sales Report",
                  exportFName: "Sales_EventDayCharges_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "eventday",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-search-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3> {formatNumberUS(Carddata.EventdayCharge)}</h3>
                    <span>Event Day Charges</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Rescheduling Fee Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: false,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total Rescheduling Fee Sales Report",
                  exportFName: "Sales_ReschedulingFee_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "rescheduling",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-search-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Reschedulingfee)}</h3>
                    <span>Rescheduling Fee</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Beverages Fee Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: false,
                  Adjustments: true,
                  Deficit: true,
                  Other: true,
                  title: "Total Beverages Fee Sales Report",
                  exportFName: "Sales_BeveragesFee_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "beverages",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-search-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Beveragesfee)}</h3>
                    <span>Beverages Fee</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Adjustment Sales Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: false,
                  Deficit: true,
                  Other: true,
                  title: "Total Adjustment Sales Report",
                  exportFName: "Sales_Adjustment_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "adjustment",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-search-dollar"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Adjustments)}</h3>
                    <span>Adjustment</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total Deficit Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: false,
                  Other: true,
                  title: "Total Deficit Report",
                  exportFName: "Sales_Deficit_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "deficit",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-trophy"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Deficit)}</h3>
                    <span>Deficit</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-md-1  Widget-hover"
            title="View Total other Report"
          >
            <a
              href={`#`}
              onClick={() => {
                var modal = document.getElementById("SModal");
                modal.style.display = "block";
                var span = document.getElementById("Salesclose");
                span.onclick = function () {
                  modal.style.display = "none";
                };

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                  if (event.target == modal) {
                    modal.style.display = "none";
                  }
                };

                setreportcolumn((prevreportcolumn) => ({
                  ...prevreportcolumn,
                  Reportflag: true,
                  Roomrental: true,
                  Decor: true,
                  RDD: true,
                  Vendor: true,
                  EventdayCharge: true,
                  Reschedulingfee: true,
                  Beveragesfee: true,
                  Adjustments: true,
                  Deficit: true,
                  Other: false,
                  title: "Total Other Report",
                  exportFName: "Sales_Other_Report",
                  refreshflag: reportcolumn.refreshflag + 1,
                  reportvalue: "Other",
                }));
              }}
            >
              <div className="card dash-widget">
                <div className="card-body">
                  <span className="dash-widget-icon">
                    <i class="las la-trophy"></i>
                  </span>
                  <div className="dash-widget-info-sales-card">
                    <h3>{formatNumberUS(Carddata.Other)}</h3>
                    <span>Other</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        {!GeoShow && (
          <>
            <div className="row">
              <div className="col-md-6">
                <Roomrental
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <Decor
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>
              <div className="col-md-6">
                <RDD
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                  IsSales={true}
                  IsRevenue={false}
                />
              </div>
              <div className="col-md-6">
                <Vendor
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                  IsSales={true}
                  IsRevenue={false}
                />
              </div>
              <div className="col-md-6">
                <Eventdaycharges
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>
              <div className="col-md-6">
                <Beverage
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                  IsSales={true}
                  IsRevenue={false}
                />
              </div>
              <div className="col-md-6">
                <Rescheduling
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>
              <div className="col-md-6">
                <Adjustment
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                  IsSales={true}
                  IsRevenue={false}
                />
              </div>
              <div className="col-md-6">
                <Deficit
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                  IsSales={true}
                  IsRevenue={false}
                />
              </div>
            </div>
          </>
        )}

        {GeoShow && <SalesMap />}

        {/* <!-- Sales Report Modal --> */}
        <div id="SModal" class="cmodal">
          <div class="cmodal-content">
            <div className="modal-header">
              <h5 className="modal-title-popup">{reportcolumn.title}</h5>
              <span class="close" id="Salesclose">
                &times;
              </span>
            </div>
            <div className="row">
              <div className="col-md-12">
                {reportcolumn.Reportflag && (
                  <KendoGrid
                    exportFileName={reportcolumn.exportFName}
                    name={"Sales_report"}
                    paggable={true}
                    url={`${baseURL}Analytics/Get_SalesData_Report?type=${metrics.type}&years=${year}&filter=${metrics.filter}&metrics=${metrics.metrices}&value=${metrics.metricesValue}&reportType=${reportcolumn.reportvalue}`}
                    schema={{
                      RoomRentalcharges: { type: "number" },
                      DecorationServicesCharges: { type: "number" },
                      RDDCharges: { type: "number" },
                      VendorServicesCharges: { type: "number" },
                      ReschedulingFeeCharges: { type: "number" },
                      Chargeofthedaycharges: { type: "number" },
                      BeverageFeeCharges: { type: "number" },
                      FunctionTotal: { type: "number" },
                      EstimatedAttendance: { type: "number" },
                      Other: { type: "number" },
                    }}
                    refreshWhen={reportcolumn.refreshflag}
                    columns={[
                      {
                        field: "EventNumber",
                        title: "Event No",
                        width: 100,
                      },
                      {
                        field: "FunctionNumber",
                        title: "Function No",
                        width: 110,
                      },
                      {
                        field: "EventName",
                        title: "Event Name",
                        width: 150,
                      },
                      {
                        field: "EventType",
                        title: "EventType",
                        width: 100,
                      },
                      {
                        field: "GuaranteedDate",
                        title: "Guaranteed Date",
                        width: 150,
                      },
                      {
                        field: "FunctionStartDate",
                        title: "StartDate",
                        width: 150,
                      },
                      {
                        field: "FunctionEndDate",
                        title: "EndDate",
                        width: 150,
                      },
                      {
                        field: "EstimatedAttendance",
                        title: "Estimated Attendance",
                        width: 150,
                      },
                      {
                        field: "FunctionTotal",
                        title: "Function Total",
                        width: 150,
                      },
                      {
                        field: "TypeofContract",
                        title: "Type of Contract",
                        width: 150,
                      },
                      {
                        field: "ContactPerson",
                        title: "Contact Person",
                        width: 150,
                      },

                      {
                        field: "PrimaryContactEmail",
                        title: "Primary Contact Email",
                        width: 150,
                      },
                      {
                        field: "RoomRentalcharges",
                        title: "Room Rental charges",
                        width: 150,
                        hidden: reportcolumn.Roomrental,
                      },
                      {
                        field: "DecorationServicesCharges",
                        title: "Decor Charges",
                        width: 150,
                        hidden: reportcolumn.Decor,
                      },
                      {
                        field: "RDDCharges",
                        title: "RDD harges",
                        width: 150,
                        hidden: reportcolumn.RDD,
                      },
                      {
                        field: "VendorServicesCharges",
                        title: "Vendor Charges",
                        width: 150,
                        hidden: reportcolumn.Vendor,
                      },
                      {
                        field: "ReschedulingFeeCharges",
                        title: "Rescheduling Charges",
                        width: 150,
                        hidden: reportcolumn.Reschedulingfee,
                      },
                      {
                        field: "Chargeofthedaycharges",
                        title: "EventDay Charges",
                        width: 150,
                        hidden: reportcolumn.EventdayCharge,
                      },
                      {
                        field: "BeverageFeeCharges",
                        title: "Beverage Charges",
                        width: 150,
                        hidden: reportcolumn.Beveragesfee,
                      },
                      {
                        field: "Other",
                        title: "Other",
                        width: 150,
                        hidden: reportcolumn.Other,
                      },
                      {
                        field: "AdjustmentsAndDiscounts",
                        title: "Adjustments And Discounts",
                        width: 150,
                        hidden: reportcolumn.Adjustments,
                      },
                      {
                        field: "FunctionLocation",
                        title: "Function Location",
                        width: 150,
                      },
                      {
                        field: "ReferralType",
                        title: "Referral Type",
                        width: 150,
                      },
                      {
                        field: "Culture",
                        title: "Culture",
                        width: 150,
                      },
                      {
                        field: "Salesperson",
                        title: "Salesperson",
                        width: 150,
                      },
                      {
                        field: "CreationDate",
                        title: "Creation Date",
                        width: 150,
                      },
                      {
                        field: "LastUpdated",
                        title: "Last Updated",
                        width: 150,
                      },
                    ]}
                    height={400}
                    showOptions={false}
                    showEdit={false}
                    showDelete={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Sales Report Modal/ --> */}
      </div>
    </>
  );
};

export default Sales;
